import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortalComponent } from './portal.component';
import { RouterModule } from '@angular/router';
import { portalRoutes } from './portal.route.config';
import { PortalService } from './portal.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(portalRoutes)
  ],
  declarations: [PortalComponent],
  entryComponents: [PortalComponent],
  exports: [PortalComponent],
  providers: [PortalService]
})
export class PortalModule { }



// WEBPACK FOOTER //
// ./src/app/portal/portal.module.ts